<script setup lang="ts">
import { onUnmounted, ref, watch } from "vue";
import { useMap } from "../composable/google-map";
import { useLib } from "../lib-loader";

type Position =
	| "top left"
	| "top center"
	| "top right"
	| "bottom left"
	| "bottom center"
	| "bottom right";

const props = defineProps<{
	position: Position;
}>();

const map = useMap();

const CoreLib = useLib("core");

const rootElement = ref<HTMLDivElement>();

onUnmounted(() => {
	rootElement.value?.remove();
});

watch(
	[map, CoreLib],
	() => {
		if (map.value == null || CoreLib.value == null) return;

		const { ControlPosition } = CoreLib.value;
		const position = getControlPosition(props.position, ControlPosition);

		const element = document.createElement("div");

		map.value.controls[position].push(element);

		rootElement.value = element;
	},
	{ immediate: true }
);

function getControlPosition(
	position: Position,
	googlePosition: typeof google.maps.ControlPosition
): google.maps.ControlPosition {
	switch (position) {
		case "top left":
			return googlePosition.TOP_LEFT;
		case "top center":
			return googlePosition.TOP_CENTER;
		case "top right":
			return googlePosition.TOP_RIGHT;
		case "bottom left":
			return googlePosition.BOTTOM_LEFT;
		case "bottom center":
			return googlePosition.BOTTOM_CENTER;
		case "bottom right":
			return googlePosition.RIGHT_BOTTOM;
	}
}
</script>

<template>
	<Teleport v-if="rootElement" :to="rootElement">
		<slot />
	</Teleport>
</template>
